import { render } from "./BlockchainIdentifier.vue?vue&type=template&id=d9441356&scoped=true"
import script from "./BlockchainIdentifier.vue?vue&type=script&lang=js"
export * from "./BlockchainIdentifier.vue?vue&type=script&lang=js"

import "./BlockchainIdentifier.vue?vue&type=style&index=0&id=d9441356&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d9441356"

export default script